import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import * as _ from 'lodash';

import { ToastService } from '../toast/toast.service';

import { FormData } from './classes/data';
import { FormSettings, FormSchemaData, FormSchemaGroupData, FormSubmitHandler } from './form.interface';

@Injectable()
export class FormService {

  /**
   * @ignore
   */
  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastService
  ) { }

  private _form_index = 1;

  /**
   * Cria um novo formulÃ¡rio
   */
  public create(data: Array<FormSchemaData> | FormSettings, onSubmit?: FormSubmitHandler): FormData {
    let groups: Array<FormSchemaGroupData> = [];
    if (_.isPlainObject(data)) {
      groups = (<FormSettings>data).groups;
      data = (<FormSettings>data).schema;
    }
    const form = new FormData(this._form_index, this.formBuilder, (<Array<FormSchemaData>>data), groups, this.toastService, onSubmit);
    this._form_index++;

    return form;
  }
}
